import { Ripple } from "primereact/ripple";
import React from "react";

interface DataListModalCloseProps {
    className?: string;
    onClose: () => void;
}

const DataListModalClose: React.FC<DataListModalCloseProps> = ({ className, onClose }) => {
    return (
        <button
            type="button"
            className="data_select_modal_close p-ripple"
            onClick={onClose}
        >
            <i className="bi bi-x"></i>
            <Ripple />
        </button>
    )
}

export default DataListModalClose;